module.exports = __webpack_public_path__ + "static/media/apf.3c9addd0.jpg";